import React from 'react'
import { Button, Card, CardContent, Grid, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { postUserData } from '../../api/users'
import PropTypes from 'prop-types'

const PaymentsFinalPage = ({ keycloakId, email, location }) => {
  const { t } = useTranslation('common')
  const pathnameFromPayment = location.pathname.slice(10)
  console.log('location', location.search)

  React.useEffect(() => !pathnameFromPayment === 'success' && postUserData(keycloakId, email), [])
  return (
    <Card mb={6}>
      <CardContent>
        <Typography variant="h3" gutterBottom className="email-seprater-text">
          {t('payments.allGood')}
        </Typography>
        <Grid container spacing={6}>
          <Grid item md={12}>
            <div>{t('common.thanksstep3')}</div>
          </Grid>
          <Grid item md={12}>
            {pathnameFromPayment === 'success' ? (
              <a href={`/register${location?.search ? location?.search : ''}`} style={{ textDecoration: 'none' }}>
                <Button variant="contained" color="primary">
                  {t('common.next')}
                </Button>
              </a>
            ) : (
              <a href="https://convention.kli.one" style={{ textDecoration: 'none' }}>
                <Button variant="contained" color="primary">
                  {t('common.closethepage')}
                </Button>
              </a>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
PaymentsFinalPage.propTypes = {
  email: PropTypes.string,
  keycloakId: PropTypes.number,
  location: PropTypes.any,
}
export default PaymentsFinalPage
